import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

export function useResizeDetection({ timeout = 400 } = {}) {
    const [isResizing, setIsResizing] = useState(false);
    const isClient = typeof window === 'object';

    useEffect(() => {
        let isMounted = true;

        if (!isClient) {
            return false;
        }

        const handleResize = () => {
            if (!isResizing && isMounted) {
                setIsResizing(true);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            isMounted = false;
            window.removeEventListener('resize', handleResize);
        };
    }, [isClient, isResizing, timeout]);

    // Set a use effect to act as a callback when the `isResizing` state gets updated
    useEffect(() => {
        if (isResizing) {
            debounce(() => {
                setIsResizing(false);
            },
            timeout,
            { leading: false, trailing: true })();
        }
    }, [isResizing, timeout]);

    return isResizing;
}
